import { render, staticRenderFns } from "./usedGroups.vue?vue&type=template&id=024bcbcb&"
import script from "./usedGroups.vue?vue&type=script&lang=js&"
export * from "./usedGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports